/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, Delegate_$type, fromEnum, runOn, markType, INotifyPropertyChanged_$type, PropertyChangedEventArgs, enumGetBox } from "igniteui-react-core";
import { Ripple } from "./Ripple";
import { List$1 } from "igniteui-react-core";
import { KeyFrameAnimationFactory } from "igniteui-react-core";
import { AnimationKeyFrameEffect } from "igniteui-react-core";
import { AnimationKeyFrameEffectTiming } from "igniteui-react-core";
import { stringReplace } from "igniteui-react-core";
import { BaseControlTheme_$type } from "igniteui-react-core";
import { CheckboxLabelPosition_$type } from "./CheckboxLabelPosition";
import { ThemeResolver } from "./ThemeResolver";
import { CornerRadius } from "igniteui-react-core";
import { NativeUI } from "igniteui-react-core";
import { Thickness } from "igniteui-react-core";
import { CheckboxChangeEventArgs } from "./CheckboxChangeEventArgs";
import { BrushUtil } from "igniteui-react-core";
import { AnimationKeyFrameProperty } from "igniteui-react-core";
import { TransformGroup } from "igniteui-react-core";
import { RotateTransform } from "igniteui-react-core";
import { TranslateTransform } from "igniteui-react-core";
import { isNaN_ } from "igniteui-react-core";
/**
 * @hidden
 */
var CheckboxView = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CheckboxView, _super);
    function CheckboxView() {
        var _this = _super.call(this) || this;
        _this.c = null;
        _this.l = null;
        _this.f = null;
        _this.j = new List$1(Delegate_$type, 0);
        _this.g = true;
        _this.q = null;
        _this.m = null;
        _this.p = null;
        _this.n = null;
        _this.d = null;
        _this.o = null;
        return _this;
    }
    CheckboxView.prototype.ad = function () {
    };
    CheckboxView.prototype.i = function () {
        return true;
    };
    CheckboxView.prototype.ab = function (a) {
        var e_1, _a;
        if (a == null) {
            try {
                for (var _b = tslib_1.__values(fromEnum(this.j)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var b = _c.value;
                    b();
                }
            }
            catch (e_1_1) {
                e_1 = { error: e_1_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_1)
                        throw e_1.error;
                }
            }
            this.j.clear();
            return;
        }
        this.l = a;
        this.l.rootWrapper.setStyleProperty("display", "flex");
        this.l.rootWrapper.setStyleProperty("flex-direction", "row");
        this.l.rootWrapper.setStyleProperty("flex-wrap", "no-wrap");
        this.l.rootWrapper.setStyleProperty("align-items", "center");
        var c = this.l.createElement("input");
        this.q = c;
        this.q.addClass("ig-native-checkbox");
        this.q.setStyleProperty("position", "absolute");
        this.q.setStyleProperty("width", "1px");
        this.q.setStyleProperty("height", "1px");
        this.q.setStyleProperty("margin", "-1px");
        this.q.setStyleProperty("border", "none");
        this.q.setStyleProperty("clip", "rect(0, 0, 0, 0)");
        this.q.setStyleProperty("outline", "0");
        this.q.setStyleProperty("pointer-events", "none");
        this.q.setStyleProperty("overflow", "hidden");
        this.q.setStyleProperty("-webkit-appearance", "none");
        this.q.setStyleProperty("-moz-appearance", "none");
        this.q.setStyleProperty("appearance", "none");
        this.q.setAttribute("type", "checkbox");
        this.q.setAttribute("id", this.c.bv);
        this.ag();
        this.j.add(c.listen("change", runOn(this, this.v)));
        this.j.add(c.listen("click", runOn(this, this.w)));
        this.j.add(c.listen("focus", runOn(this, this.x)));
        this.j.add(c.listen("blur", runOn(this, this.u)));
        this.l.append(c);
        var d = this.l.createElement("div");
        d.addClass("ig-checkbox-box");
        d.setStyleProperty("width", "1.25em");
        d.setStyleProperty("height", "1.25em");
        d.setStyleProperty("position", "relative");
        this.m = d;
        this.l.append(d);
        var e = this.l.createElement("label");
        e.setAttribute("for", this.c.bv);
        e.addClass("ig-checkbox-composite");
        e.setStyleProperty("box-sizing", "border-box");
        e.setStyleProperty("position", "relative");
        e.setStyleProperty("display", "inline-block");
        e.setStyleProperty("cursor", "pointer");
        e.setStyleProperty("width", "1.25em");
        e.setStyleProperty("height", "1.25em");
        e.setStyleProperty("min-width", "1.25em");
        e.setStyleProperty("border-width", "0.125rem");
        e.setStyleProperty("border-style", "solid");
        e.setStyleProperty("border-color", "rgba(0,0,0,0.54)");
        e.setStyleProperty("border-top-color", "rgba(0, 0, 0, 0.54)");
        e.setStyleProperty("border-right-color", "rgba(0, 0, 0, 0.54)");
        e.setStyleProperty("border-bottom-color", "rgba(0, 0, 0, 0.54)");
        e.setStyleProperty("border-left-color", "rgba(0, 0, 0, 0.54)");
        e.setStyleProperty("border-radius", "2px");
        e.setStyleProperty("-webkit-tap-highlight-color", "transparent");
        e.setStyleProperty("overflow", "hidden");
        this.p = e;
        this.m.append(e);
        var f = this.l.createElementNS("svg", "http://www.w3.org/2000/svg");
        f.setAttribute("viewBox", "0 0 24 24");
        f.addClass("ig-checkbox-mark");
        f.setStyleProperty("position", "absolute");
        f.setStyleProperty("top", "0");
        f.setStyleProperty("left", "0");
        f.setStyleProperty("right", "0");
        f.setStyleProperty("bottom", "0");
        f.setStyleProperty("stroke", "#fff");
        f.setStyleProperty("stroke-linecap", "square");
        f.setStyleProperty("stroke-width", "3");
        f.setStyleProperty("stroke-dasharray", "24");
        f.setStyleProperty("stroke-dashoffset", "24");
        f.setStyleProperty("fill", "none");
        f.setStyleProperty("opacity", "0");
        f.setStyleProperty("z-index", "1");
        this.n = f;
        e.append(f);
        var g = this.l.createElementNS("path", "http://www.w3.org/2000/svg");
        g.setAttribute("d", "M4.1,12.7 9,17.6 20.3,6.3");
        f.append(g);
        var h = this.l.createElement("div");
        var i = this.l.getSubRenderer(h);
        h.setStyleProperty("position", "absolute");
        h.setStyleProperty("width", "3em");
        h.setStyleProperty("height", "3em");
        h.setStyleProperty("right", "calc(50% - 1.5em)");
        h.setStyleProperty("top", "calc(50% - 1.5em)");
        h.setStyleProperty("border-radius", "24px");
        h.setStyleProperty("overflow", "hidden");
        var j = new Ripple();
        j.provideContainer(i);
        j.p = d;
        var k = this.l.getExternal(j, this.l.rootWrapper, this.l.getExternal(this.c, null, null));
        j.g = true;
        j.j = true;
        this.d = j;
        d.append(h);
        var l = this.l.createElement("span");
        l.addClass("ig-checkbox-label");
        l.setStyleProperty("font-family", "'Segoe UI', Verdana");
        l.setStyleProperty("font-weight", "400");
        l.setStyleProperty("font-size", "1rem");
        l.setStyleProperty("letter-spacing", ".00937rem");
        l.setStyleProperty("text-transform", "none");
        l.setStyleProperty("line-height", "1.5rem");
        l.setStyleProperty("margin-left", "8px");
        l.setStyleProperty("margin-top", "0");
        l.setStyleProperty("margin-bottom", "0");
        l.setStyleProperty("cursor", "pointer");
        l.setStyleProperty("role", "label");
        this.o = l;
        this.j.add(l.listen("click", runOn(this, this.t)));
        this.l.append(l);
        this.l.getPortal(l, "ChildContent", function (m) {
        }, true);
        this.c.cj();
    };
    CheckboxView.prototype.t = function (a) {
        this.c.toggle();
    };
    CheckboxView.prototype.ag = function () {
        if (this.i()) {
            var a = this.c.bv;
            this.q.setAttribute("name", this.c.b4);
            this.q.setProperty("value", this.c.a3);
            if (this.c.u) {
                this.q.setAttribute("tabindex", this.c.az.toString());
            }
            this.q.setProperty("disabled", this.c.disabled);
            this.q.setProperty("indeterminate", this.c.indeterminate);
            this.q.setProperty("checked", this.c.checked);
            this.q.setProperty("required", this.c.ay);
            if (this.c.indeterminate) {
                this.q.setAttribute("aria-checked", "mixed");
            }
            else {
                this.q.setAttribute("aria-checked", this.c.checked ? "true" : "false");
            }
            this.q.setAttribute("aria-labelledby", this.c.bj);
            this.q.setAttribute("aria-label", this.c.bi);
        }
    };
    CheckboxView.prototype.ae = function () {
        if (this.i()) {
            var a = this.c.bv;
            this.q.setAttribute("id", a);
            this.p.setAttribute("for", a);
        }
    };
    CheckboxView.prototype.u = function (a) {
        this.c.focused = false;
    };
    CheckboxView.prototype.x = function (a) {
        this.c.focused = true;
    };
    CheckboxView.prototype.w = function (a) {
        a.stopPropagation();
        if (this.h()) {
            var native_ = this.q.getNativeElement();
            native_.blur();
        }
        this.c.toggle();
    };
    CheckboxView.prototype.h = function () {
        return false;
    };
    CheckboxView.prototype.v = function (a) {
        a.stopPropagation();
    };
    CheckboxView.prototype.y = function () {
        if (KeyFrameAnimationFactory.h == null) {
            KeyFrameAnimationFactory.h = this.l;
        }
    };
    CheckboxView.prototype.a = function (a) {
        return new AnimationKeyFrameEffect(0, this.p, 0, null, a);
    };
    CheckboxView.prototype.b = function (a) {
        return new AnimationKeyFrameEffect(0, this.n, 0, null, a);
    };
    CheckboxView.prototype.z = function (a) {
    };
    Object.defineProperty(CheckboxView.prototype, "r", {
        get: function () {
            return this.p;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckboxView.prototype, "e", {
        get: function () {
            return this.d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckboxView.prototype, "s", {
        get: function () {
            return this.n;
        },
        enumerable: true,
        configurable: true
    });
    CheckboxView.prototype.aa = function () {
        this.g = true;
        this.j.add(this.q.listen("change", runOn(this, this.v)));
        this.j.add(this.q.listen("click", runOn(this, this.w)));
        this.j.add(this.q.listen("focus", runOn(this, this.x)));
        this.j.add(this.q.listen("blur", runOn(this, this.u)));
        this.j.add(this.o.listen("click", runOn(this, this.t)));
    };
    CheckboxView.prototype.ac = function () {
        var e_2, _a;
        this.g = false;
        try {
            for (var _b = tslib_1.__values(fromEnum(this.j)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var a = _c.value;
                a();
            }
        }
        catch (e_2_1) {
            e_2 = { error: e_2_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_2)
                    throw e_2.error;
            }
        }
        this.j.clear();
    };
    CheckboxView.prototype.af = function () {
        var model_ = this.c;
        if (model_.externalObject && model_.externalObject.refreshDefaults) {
            model_.externalObject.refreshDefaults();
        }
        ;
    };
    CheckboxView.prototype.ah = function (a, b) {
        this.d.au = a;
        this.d.at = b;
    };
    CheckboxView.prototype.k = function () {
        var a = this.p.getStyleProperty("border-top-width");
        a = stringReplace(a, "px", "");
        return parseFloat(a);
    };
    CheckboxView.$t = markType(CheckboxView, 'CheckboxView');
    return CheckboxView;
}(Base));
export { CheckboxView };
/**
 * @hidden
 */
var Checkbox = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(Checkbox, _super);
    function Checkbox() {
        var _this = _super.call(this) || this;
        _this._view = null;
        _this.b = 0;
        _this.m = false;
        _this.aa = false;
        _this.c0 = null;
        _this.cv = ThemeResolver.e(Checkbox.c, Checkbox.dj, Checkbox.de);
        _this.cx = null;
        _this.cz = null;
        _this.cu = ThemeResolver.e(Checkbox.c, Checkbox.di, Checkbox.dd);
        _this.c1 = null;
        _this.cy = null;
        _this.dn = ThemeResolver.e(Checkbox.c, Checkbox.dk, Checkbox.df);
        _this.da = ThemeResolver.e(Checkbox.c, Checkbox.dh, Checkbox.dc);
        _this.am = ThemeResolver.b(Checkbox.c, Checkbox.ar, Checkbox.ao);
        _this.c9 = ThemeResolver.e(Checkbox.c, Checkbox.dg, Checkbox.db);
        _this.an = ThemeResolver.b(Checkbox.c, Checkbox.as, Checkbox.ap);
        _this.dl = ThemeResolver.e(Checkbox.c, Checkbox.di, Checkbox.dd);
        _this.au = ThemeResolver.b(Checkbox.c, Checkbox.at, Checkbox.aq);
        _this.dm = ThemeResolver.e(Checkbox.c, Checkbox.dj, Checkbox.de);
        _this.cw = ThemeResolver.e(Checkbox.c, Checkbox.dk, Checkbox.df);
        _this.ct = ThemeResolver.e(Checkbox.c, Checkbox.dh, Checkbox.dc);
        _this.ae = NaN;
        _this.ab = ThemeResolver.b(Checkbox.c, Checkbox.ar, Checkbox.ao);
        _this.af = NaN;
        _this.ag = NaN;
        _this.ad = ThemeResolver.b(Checkbox.c, Checkbox.at, Checkbox.aq);
        _this.ac = ThemeResolver.b(Checkbox.c, Checkbox.as, Checkbox.ap);
        _this.cs = ThemeResolver.e(Checkbox.c, Checkbox.dg, Checkbox.db);
        _this.a7 = "ig-native-checkbox-" + Checkbox.a1++;
        _this.a6 = "ig-checkbox-" + Checkbox.a0++;
        _this.a8 = null;
        _this.a2 = null;
        _this.a9 = null;
        _this.ax = 0;
        _this.n = false;
        _this.aw = 0;
        _this.q = false;
        _this.a5 = null;
        _this.a4 = null;
        _this.change = null;
        _this.f = 0;
        _this.k = false;
        _this.o = false;
        _this.r = false;
        _this.p = false;
        _this.l = false;
        _this.i = null;
        _this.j = null;
        _this.propertyChanged = null;
        _this.a8 = _this.a6 + "-label";
        _this.a5 = _this.a8;
        var a = new CheckboxView();
        a.c = _this;
        _this.view = a;
        _this.view.ad();
        return _this;
    }
    Object.defineProperty(Checkbox.prototype, "view", {
        get: function () {
            return this._view;
        },
        set: function (a) {
            this._view = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "d", {
        get: function () {
            return this.b;
        },
        set: function (a) {
            var b = this.b;
            this.b = a;
            if (b != this.b) {
                this.ci("BaseTheme", enumGetBox(BaseControlTheme_$type, b), enumGetBox(BaseControlTheme_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Checkbox.prototype.destroy = function () {
        this.provideContainer(null);
    };
    Checkbox.prototype.ci = function (a, b, c) {
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
        this.ck(a, b, c);
    };
    Checkbox.prototype.co = function () {
        this.c4 = this.dp != null ? this.dp : this.dl;
        this.c6 = this.dr != null ? this.dr : this.dn;
        this.c3 = this.c8 != null ? this.c8 : this.da;
        this.ah = !isNaN_(this.ak) ? this.ak : this.am;
        this.c2 = this.c7 != null ? this.c7 : this.c9;
        this.c5 = this.dq != null ? this.dq : this.dm;
        this.ai = !isNaN_(this.al) ? this.al : this.an;
        this.aj = !isNaN_(this.av) ? this.av : this.au;
    };
    Checkbox.prototype.ck = function (a, b, c) {
        switch (a) {
            case "BaseTheme":
                this.cr(this.d);
                this.co();
                break;
            case "TickColor":
                this.c4 = this.dp != null ? this.dp : this.dl;
                break;
            case "UncheckedBorderColor":
                this.c6 = this.dr != null ? this.dr : this.dn;
                break;
            case "CheckedBorderColor":
                this.c3 = this.c8 != null ? this.c8 : this.da;
                break;
            case "BorderWidth":
                this.ah = !isNaN_(this.ak) ? this.ak : this.am;
                break;
            case "CheckedBackgroundColor":
                this.c2 = this.c7 != null ? this.c7 : this.c9;
                break;
            case "UncheckedBackgroundColor":
                this.c5 = this.dq != null ? this.dq : this.dm;
                break;
            case "CornerRadius":
                this.ai = !isNaN_(this.al) ? this.al : this.an;
                break;
            case "TickStrokeWidth":
                this.aj = !isNaN_(this.av) ? this.av : this.au;
                break;
            case "ActualTickStrokeWidth":
            case "ActualTickColor":
                this.cq();
                break;
            case "ActualCheckedBackgroundColor":
            case "ActualUncheckedBackgroundColor":
            case "ActualUncheckedBorderColor":
            case "ActualCheckedBorderColor":
            case "ActualBorderWidth":
                if (this.i != null) {
                    this.i.cancel();
                }
                if (this.j != null) {
                    this.j.cancel();
                }
                this.i = null;
                this.j = null;
                this.cn();
                var d = (this.t);
                this.t = true;
                this.cp(this.indeterminate);
                this.t = d;
                break;
            case "ActualCornerRadius":
                this.cn();
                break;
            case "IsChecked":
                if (!this.m) {
                    var e = this.indeterminate;
                    this.m = true;
                    this.indeterminate = false;
                    this.m = false;
                    var f = (this.t);
                    this.t = true;
                    this.cp(e);
                    this.t = f;
                }
                break;
            case "IsIndeterminate":
                if (!this.m) {
                    this.cp(b);
                }
                break;
            case "DisableRipple":
                this.view.e.h = this.s;
                break;
            case "InputId":
                this.view.ae();
                break;
        }
    };
    Checkbox.prototype.cn = function () {
        var a = this.view.r;
        NativeUI.l(a, new CornerRadius(0, this.ai));
        if (!isNaN_(this.ah)) {
            NativeUI.m(a, new Thickness(0, this.ah));
        }
        if (this.checked) {
            NativeUI.j(a, this.c2);
            NativeUI.k(a, this.c3);
        }
        else {
            NativeUI.j(a, this.c5);
            NativeUI.k(a, this.c6);
        }
    };
    Checkbox.prototype.cq = function () {
        var a = this.view.s;
        NativeUI.v(a, this.c4);
        NativeUI.y(a, this.aj);
    };
    Object.defineProperty(Checkbox.prototype, "dq", {
        get: function () {
            return this.c0;
        },
        set: function (a) {
            var b = this.c0;
            this.c0 = a;
            if (b != this.c0) {
                this.ci("UncheckedBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "c5", {
        get: function () {
            return this.cv;
        },
        set: function (a) {
            var b = this.cv;
            this.cv = a;
            if (b != this.cv) {
                this.ci("ActualUncheckedBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "c7", {
        get: function () {
            return this.cx;
        },
        set: function (a) {
            var b = this.cx;
            this.cx = a;
            if (b != this.cx) {
                this.ci("CheckedBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "dp", {
        get: function () {
            return this.cz;
        },
        set: function (a) {
            var b = this.cz;
            this.cz = a;
            if (b != this.cz) {
                this.ci("TickColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "c4", {
        get: function () {
            return this.cu;
        },
        set: function (a) {
            var b = this.cu;
            this.cu = a;
            if (b != this.cu) {
                this.ci("ActualTickColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "dr", {
        get: function () {
            return this.c1;
        },
        set: function (a) {
            var b = this.c1;
            this.c1 = a;
            if (b != this.c1) {
                this.ci("UncheckedBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "c8", {
        get: function () {
            return this.cy;
        },
        set: function (a) {
            var b = this.cy;
            this.cy = a;
            if (b != this.cy) {
                this.ci("CheckedBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Checkbox.prototype.cr = function (a) {
        this.dn = ThemeResolver.e(a, Checkbox.dk, Checkbox.df);
        this.da = ThemeResolver.e(a, Checkbox.dh, Checkbox.dc);
        this.am = ThemeResolver.b(a, Checkbox.ar, Checkbox.ao);
        this.c9 = ThemeResolver.e(a, Checkbox.dg, Checkbox.db);
        this.an = ThemeResolver.b(a, Checkbox.as, Checkbox.ap);
        this.dl = ThemeResolver.e(a, Checkbox.di, Checkbox.dd);
        this.au = ThemeResolver.b(a, Checkbox.at, Checkbox.aq);
        this.dm = ThemeResolver.e(a, Checkbox.dj, Checkbox.de);
    };
    Object.defineProperty(Checkbox.prototype, "c6", {
        get: function () {
            return this.cw;
        },
        set: function (a) {
            var b = this.cw;
            this.cw = a;
            if (b != this.cw) {
                this.ci("ActualUncheckedBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "c3", {
        get: function () {
            return this.ct;
        },
        set: function (a) {
            var b = this.ct;
            this.ct = a;
            if (b != this.ct) {
                this.ci("ActualCheckedBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "ak", {
        get: function () {
            return this.ae;
        },
        set: function (a) {
            var b = this.ae;
            this.ae = a;
            if (b != this.ae) {
                this.ci("BorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "ah", {
        get: function () {
            return this.ab;
        },
        set: function (a) {
            var b = this.ab;
            this.ab = a;
            if (b != this.ab) {
                this.ci("ActualBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "al", {
        get: function () {
            return this.af;
        },
        set: function (a) {
            var b = this.af;
            this.af = a;
            if (b != this.af) {
                this.ci("CornerRadius", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "av", {
        get: function () {
            return this.ag;
        },
        set: function (a) {
            var b = this.ag;
            this.ag = a;
            if (b != this.ag) {
                this.ci("TickStrokeWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "aj", {
        get: function () {
            return this.ad;
        },
        set: function (a) {
            var b = this.ad;
            this.ad = a;
            if (b != this.ad) {
                this.ci("ActualTickStrokeWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "ai", {
        get: function () {
            return this.ac;
        },
        set: function (a) {
            var b = this.ac;
            this.ac = a;
            if (b != this.ac) {
                this.ci("ActualCornerRadius", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "c2", {
        get: function () {
            return this.cs;
        },
        set: function (a) {
            var b = this.cs;
            this.cs = a;
            if (b != this.cs) {
                this.ci("ActualCheckedBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "bv", {
        get: function () {
            return this.a7;
        },
        set: function (a) {
            var b = this.a7;
            this.a7 = a;
            if (b != this.a7) {
                this.ci("InputId", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "bt", {
        get: function () {
            return this.a6;
        },
        set: function (a) {
            var b = this.a6;
            this.a6 = a;
            if (b != this.a6) {
                this.ci("Id", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "labelId", {
        get: function () {
            return this.a8;
        },
        set: function (a) {
            var b = this.a8;
            this.a8 = a;
            if (b != this.a8) {
                this.ci("LabelId", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "a3", {
        get: function () {
            return this.a2;
        },
        set: function (a) {
            var b = this.a2;
            this.a2 = a;
            if (b != this.a2) {
                this.ci("Value", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "b4", {
        get: function () {
            return this.a9;
        },
        set: function (a) {
            var b = this.a9;
            this.a9 = a;
            if (b != this.a9) {
                this.ci("Name", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "u", {
        get: function () {
            return this.n;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "az", {
        get: function () {
            return this.ax;
        },
        set: function (a) {
            var b = this.ax;
            this.ax = a;
            this.n = true;
            if (b != this.ax) {
                this.ci("TabIndex", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "ay", {
        get: function () {
            return this.aw;
        },
        set: function (a) {
            var b = this.aw;
            this.aw = a;
            if (b != this.aw) {
                this.ci("Required", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "focused", {
        get: function () {
            return this.q;
        },
        set: function (a) {
            var b = this.q;
            this.q = a;
            if (b != this.q) {
                this.ci("IsFocused", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "bj", {
        get: function () {
            return this.a5;
        },
        set: function (a) {
            var b = this.a5;
            this.a5 = a;
            if (b != this.a5) {
                this.ci("AriaLabelledBy", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "bi", {
        get: function () {
            return this.a4;
        },
        set: function (a) {
            var b = this.a4;
            this.a4 = a;
            if (b != this.a4) {
                this.ci("AriaLabel", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "g", {
        get: function () {
            return this.f;
        },
        set: function (a) {
            var b = this.f;
            this.f = a;
            if (b != this.f) {
                this.ci("LabelPosition", enumGetBox(CheckboxLabelPosition_$type, b), enumGetBox(CheckboxLabelPosition_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "s", {
        get: function () {
            return this.k;
        },
        set: function (a) {
            var b = this.k;
            this.k = a;
            if (b != this.k) {
                this.ci("DisableRipple", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "checked", {
        get: function () {
            return this.o;
        },
        set: function (a) {
            var b = this.o;
            this.o = a;
            if (b != this.o) {
                this.ci("IsChecked", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "indeterminate", {
        get: function () {
            return this.r;
        },
        set: function (a) {
            var b = this.r;
            this.r = a;
            if (b != this.r) {
                this.ci("IsIndeterminate", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "disabled", {
        get: function () {
            return this.p;
        },
        set: function (a) {
            var b = this.p;
            this.p = a;
            if (b != this.p) {
                this.ci("IsDisabled", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Checkbox.prototype, "t", {
        get: function () {
            return this.l;
        },
        set: function (a) {
            var b = this.l;
            this.l = a;
            if (b != this.l) {
                this.ci("DisableTransitions", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Checkbox.prototype.cj = function () {
        this.ce();
        if (this.checked) {
            this.view.ah(BrushUtil.n(this.c2, 0.6), BrushUtil.n(this.c2, 0.1));
        }
        else {
            this.view.ah(BrushUtil.n(this.c2, 0.6), BrushUtil.n(this.c6, 0.1));
        }
    };
    Object.defineProperty(Checkbox.prototype, "a", {
        get: function () {
            var a = new AnimationKeyFrameEffectTiming();
            a.g = 300;
            a.b = 0;
            return a;
        },
        enumerable: true,
        configurable: true
    });
    Checkbox.prototype.ce = function () {
        this.view.y();
        var a = false;
        if (this.i == null) {
            if (!a) {
                a = true;
                this.view.af();
            }
            this.i = KeyFrameAnimationFactory.f.c(this.view.a(this.a).m(new AnimationKeyFrameProperty(2, this.c5), new AnimationKeyFrameProperty(3, this.c6)).m(new AnimationKeyFrameProperty(2, this.c2), new AnimationKeyFrameProperty(3, this.c3)));
            this.j = KeyFrameAnimationFactory.f.c(this.view.b(this.a).m(new AnimationKeyFrameProperty(19, 24), new AnimationKeyFrameProperty(1, 0)).m(new AnimationKeyFrameProperty(19, 0), new AnimationKeyFrameProperty(1, 1)));
        }
    };
    Checkbox.prototype.toggle = function () {
        if (this.disabled) {
            return;
        }
        this.ce();
        this.focused = false;
        this.m = true;
        var a = false;
        if (this.indeterminate) {
            a = true;
            this.checked = true;
        }
        this.indeterminate = false;
        this.checked = !this.checked;
        this.m = false;
        this.cp(a);
        if (this.change != null) {
            var b = new CheckboxChangeEventArgs();
            b.isChecked = this.checked;
            b.isIndeterminate = this.indeterminate;
            this.change(this, b);
        }
    };
    Checkbox.prototype.cp = function (a) {
        var _this = this;
        this.ce();
        var b = this.checked;
        if (this.indeterminate) {
            b = true;
        }
        var c = 1;
        if (!b) {
            c = -1;
        }
        if (b) {
            this.view.ah(BrushUtil.n(this.c2, 0.6), BrushUtil.n(this.c2, 0.1));
        }
        else {
            this.view.ah(BrushUtil.n(this.c2, 0.6), BrushUtil.n(this.c6, 0.1));
        }
        if (!this.indeterminate) {
            NativeUI.z(this.view.s, null);
        }
        if (this.t || this.indeterminate || a) {
            var d = this.view.r;
            var e = this.view.s;
            if (this.indeterminate) {
                var f = new TransformGroup();
                f.j.add(((function () {
                    var $ret = new RotateTransform();
                    $ret.j = 45;
                    return $ret;
                })()));
                f.j.add(((function () {
                    var $ret = new TranslateTransform();
                    $ret.j = -_this.view.k();
                    return $ret;
                })()));
                NativeUI.j(d, this.c2);
                NativeUI.k(d, this.c3);
                NativeUI.t(e, 1);
                NativeUI.x(e, 41);
                NativeUI.z(e, f);
            }
            else if (b) {
                NativeUI.j(d, this.c2);
                NativeUI.k(d, this.c3);
                NativeUI.t(e, 1);
                NativeUI.x(e, 0);
            }
            else {
                NativeUI.j(d, this.c5);
                NativeUI.k(d, this.c6);
                NativeUI.t(e, 0);
                NativeUI.x(e, 24);
            }
            return;
        }
        if ((c > 0 && this.i.playbackRate < 0) || (c < 0 && this.i.playbackRate > 0)) {
            this.i.reverse();
            this.i.finished.f(function (g) {
                if (_this.i != null) {
                    _this.i.commitStyles();
                }
            });
            this.j.reverse();
            this.j.finished.f(function (g) {
                if (_this.j != null) {
                    _this.j.commitStyles();
                }
            });
        }
        else {
            this.i.play();
            this.i.finished.f(function (g) {
                if (_this.i != null) {
                    _this.i.commitStyles();
                }
            });
            this.j.play();
            this.j.finished.f(function (g) {
                if (_this.j != null) {
                    _this.j.commitStyles();
                }
            });
        }
    };
    Checkbox.prototype.onDetachedFromUI = function () {
        this.view.ac();
    };
    Checkbox.prototype.onAttachedToUI = function () {
        this.view.aa();
    };
    Checkbox.prototype.onContentReady = function () {
        if (this.indeterminate) {
            this.cp(false);
        }
    };
    Checkbox.prototype.z = function () {
        return this.view.i();
    };
    Checkbox.prototype.provideContainer = function (a) {
        this.view.ab(a);
    };
    Checkbox.$t = markType(Checkbox, 'Checkbox', Base.$, [INotifyPropertyChanged_$type]);
    Checkbox.dk = BrushUtil.g(138, 0, 0, 0);
    Checkbox.dh = BrushUtil.g(138, 0, 0, 0);
    Checkbox.ar = NaN;
    Checkbox.dg = BrushUtil.g(255, 228, 28, 119);
    Checkbox.as = 2;
    Checkbox.di = BrushUtil.g(255, 255, 255, 255);
    Checkbox.at = 3;
    Checkbox.dj = BrushUtil.g(255, 255, 255, 255);
    Checkbox.df = BrushUtil.g(255, 153, 153, 153);
    Checkbox.dc = BrushUtil.g(138, 33, 150, 243);
    Checkbox.ao = NaN;
    Checkbox.db = BrushUtil.g(255, 33, 150, 243);
    Checkbox.ap = 2;
    Checkbox.dd = BrushUtil.g(255, 255, 255, 255);
    Checkbox.aq = 3;
    Checkbox.de = BrushUtil.g(255, 255, 255, 255);
    Checkbox.c = 2;
    Checkbox.a1 = 0;
    Checkbox.a0 = 0;
    return Checkbox;
}(Base));
export { Checkbox };
//# sourceMappingURL=CheckboxView_combined.js.map
